import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AGENT_BUILDER_ROUTE } from '../shared/constants/routes';
import { AgentBuilderComponent } from './agent-builder/agent-builder.component';

const routes: Routes = [
  {
    path: AGENT_BUILDER_ROUTE,
    component: AgentBuilderComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AgentBuilderRoutingModule {}
